import type { ReactNode } from 'react'

import { TenantProvider } from '@/tenant/TenantProvider.tsx'

import { AstryxThemeProvider } from './AstryxThemeProvider.tsx'
import { QueryProvider } from './QueryProvider.tsx'

interface AppProvidersProps {
  readonly children: ReactNode
}

/**
 * Single composition point for cross-cutting providers.
 *
 * Order: data client, then tenant, then theme.
 *
 * The query client is outermost because it depends on nothing. The theme sits
 * innermost because the accent is tenant configuration, and reading it means
 * reading the studio's profile — which is a query. Putting the theme above the
 * query client would leave every studio wearing the same colours.
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <TenantProvider>
        <AstryxThemeProvider>{children}</AstryxThemeProvider>
      </TenantProvider>
    </QueryProvider>
  )
}
